export default [
  {
    id: "All",
    title: "All",
  },
  {
    id: "Today",
    title: "Today",
  },
  {
    id: "Yesterday",
    title: "Yesterday",
  },
  {
    id: "WTD",
    title: "Week to Date",
  },
  {
    id: "LW",
    title: "Last Week",
  },
  {
    id: "MTD",
    title: "Month to Date",
  },
  {
    id: "LM",
    title: "Last Month",
  },
  {
    id: "Last30",
    title: "Last 30 Days",
  },
  {
    id: "QTD",
    title: "Quarter to Date",
  },
  {
    id: "YTD",
    title: "Year to Date",
  },
  {
    id: "Last365",
    title: "Last 12 Months",
  },
  {
    id: "LastYear",
    title: "Last Year",
  },
  {
    id: "ShippingThisWeek",
    title: "Shipping This Week",
  },
];
